var render = function render(){var _vm=this,_c=_vm._self._c;return _c('travel-svg',_vm._b({staticClass:"travel-svg",staticStyle:{"position":"absolute","left":"0","top":"0"}},'travel-svg',_vm.vueBind,false))
}
var staticRenderFns = []

export { render, staticRenderFns }